import { Attori } from '../shared/enum/attori.enum';
import { BaseFilter } from './base-filter.interface';

export interface FiltroRettifiche extends BaseFilter {
  login?: string | null;
  matricola?: string | null;
  risorsa?: string | null;
  codiceCommessaSorgente?: string | null;
  descrizioneCommessaSorgente?: string | null;
  codiceCommessaDestinazione?: string | null;
  descrizioneCommessaDestinazione?: string | null;
  commessaSorgente?: string | null;
  commessaDestinazione?: string | null;
  responsabileGerarchico?: string | null;
  responsabileCommessaSorgente?: string | null;
  responsabileCommessaDestinazione?: string | null;
  idStatoRichiestaRettifica?: number | null;
  richiestaPerAttore?: Attori | null;
  interventoSorgente?: string | null;
  interventoDestinazione?: string | null;
  iterConcluso?: boolean | null;
}

export const filtroRettificheVuoto: FiltroRettifiche = {
  login: null,
  matricola: null,
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileGerarchico: null,
  responsabileCommessaSorgente: null,
  responsabileCommessaDestinazione: null,
  idStatoRichiestaRettifica: null,
  iterConcluso: null,
  interventoSorgente: null,
  interventoDestinazione: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export interface FiltroRettificheRCD extends BaseFilter {
  matricola?: string | null;
  risorsa?: string | null;
  descrizioneCommessaSorgente?: string | null;
  descrizioneCommessaDestinazione?: string | null;
  responsabileGerarchico?: string | null;
  idStatoRichiestaRettifica?: number | null;
}
export interface FiltroRettificheRisorsaRcd extends BaseFilter {
  matricola?: string | null;
}

export const filtroRettificheRCDVuoto: FiltroRettificheRCD = {
  matricola: null,
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileGerarchico: null,
  idStatoRichiestaRettifica: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export const FiltroRettificheRisorsaRcdVuoto: FiltroRettificheRisorsaRcd = {
  matricola: null,
  pageNumber: 1,
  pageSize: 1000,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export interface FiltroRettificheRpl extends BaseFilter {
  risorsa?: string | null;
  descrizioneCommessaSorgente?: string | null;
  descrizioneCommessaDestinazione?: string | null;
  iterConcluso?: boolean | null;
  richiestaPerAttore?: Attori | null;
}

export interface FiltroRettificheRgRpl extends FiltroRettificheRpl {
  responsabileGerarchico?: string | null;
}

export interface FiltroRettificheRcdRpl extends FiltroRettificheRpl {
  responsabileCommessaDestinazione?: string | null;
}

export const filtroRettificheRgRplVuoto: FiltroRettificheRgRpl = {
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileGerarchico: null,
  iterConcluso: null,
  richiestaPerAttore: Attori.ResponsabileGerarchico,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export const filtroRettificheRcdRplVuoto: FiltroRettificheRcdRpl = {
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileCommessaDestinazione: null,
  iterConcluso: null,
  richiestaPerAttore: Attori.ResponsabileCommessaDestinazione,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export const filtroRettificheRcdCooCfoVuoto: FiltroRettificheRcdRpl = {
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileCommessaDestinazione: null,
  iterConcluso: null,
  richiestaPerAttore: Attori.ResponsabileCommessaDestinazione,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export const filtroRettificheRgCooCfoVuoto: FiltroRettificheRgRpl = {
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileGerarchico: null,
  iterConcluso: null,
  richiestaPerAttore: Attori.ResponsabileGerarchico,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export interface FiltroRettifichePC
  extends FiltroRettificheRpl,
    FiltroRettificheRgRpl,
    FiltroRettificheRcdRpl {}

export const filtroRettifichePCVuoto: FiltroRettifichePC = {
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileGerarchico: null,
  responsabileCommessaDestinazione: null,
  iterConcluso: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};

export interface FiltroRettificheCC extends FiltroRettifichePC {
  responsabileCommessaSorgente?: string | null;
  descrizioneInterventoSorgente?: string | null;
  descrizioneInterventoDestinazione?: string | null;
}

export const filtroRettificheCCVuoto: FiltroRettificheCC = {
  risorsa: null,
  descrizioneCommessaSorgente: null,
  descrizioneCommessaDestinazione: null,
  responsabileGerarchico: null,
  responsabileCommessaSorgente: null,
  responsabileCommessaDestinazione: null,
  descrizioneInterventoSorgente: null,
  descrizioneInterventoDestinazione: null,
  iterConcluso: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};
